"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.b64_2ab = void 0;
function b64_2ab(v) {
    if (v instanceof ArrayBuffer) {
        return v;
    }
    if (v instanceof Uint8Array) {
        return v.buffer;
    }
    if (typeof v === 'string') {
        const bs = (Buffer && Buffer.from(v, 'base64').toString('ascii')) || atob(v);
        const data = new Uint8Array(bs.length);
        for (let i = 0; i < bs.length; i++) {
            data[i] = bs.charCodeAt(i);
        }
        return data.buffer;
    }
    return v;
}
exports.b64_2ab = b64_2ab;
//# sourceMappingURL=ModelHelper.js.map